import { useParams } from 'react-router-dom';
import { CheckboxToggle } from 'react-rainbow-components';
import { Phonenumber } from 'data/firestore/agent/customer/phonenumber/types';
import useManageCustomerFallbackNumbers from 'data/hooks/useManageCustomerFallbackNumbers';
import { ActionsCellWrapper } from './styled';

interface Props {
    row?: Phonenumber;
}

const VerifyPhoneNumber = ({
    row,
}: Props) => {
    const { agentId = '', customerId = '' } = useParams();
    const {
        verify,
    } = useManageCustomerFallbackNumbers({ agentId, customerId });

    if (!row) return null;

    return (
        <ActionsCellWrapper>
            <CheckboxToggle
                value={row.verified || false}
                onChange={(event) => verify(row.id, event.target.checked)}
            />
        </ActionsCellWrapper>
    );
};

export default VerifyPhoneNumber;
